import React, { Component } from "react";
import { Helmet } from "react-helmet";

import { withRouter, NavLink } from "react-router-dom";
import _ from "lodash";
import store from "store2";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { login, cleanUp } from "../../store/user/actions";

//mui
import { withStyles } from "@material-ui/core/styles";
import { materialUiStyles } from '../../config';


import Btn from '../../Components/Btn';
import Alert from '../../Components/Alert';

const styles = materialUiStyles;

class Login extends Component {
  state = {
    email: '',
    password: ''
  };

  componentDidMount() {
    window.addEventListener("keydown", this.handleEnterDown);
    store.clearAll();
    console.log(this.props)
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEnterDown);
  }

  handleEnterDown = e => {
    if (e.keyCode === 13) {
      this.login();
    }
  }

  handleChange = (e) => {
    let errors = {};
    // eg, email + Error = emailError
    errors[e.target.name + "Error"] = null;

    this.setState({
      [e.target.name]: e.target.value,
      ...errors
    })
  }

  /**
   * @param {Event} e
   */
  login = (e) => {
    e && e.preventDefault();
    // use prop "referer" to redirect to the requested page after login success
    let referer = (this.props.location.state && this.props.location.state.from && this.props.location.state.from.state.referer) || "/bookings";

    if (_.has(this.props.location, 'state.referer')) {
      referer = this.props.location.state.referer;
    }

    this.props.login({
      email: this.state.email,
      password: this.state.password
    }, { referer, history: this.props.history });
  }

  getAlertMessage = (success) => {
    if (!success) return undefined;

    if (success) {
      return "Password changed successfully, please login.";
    }
  }

  render() {
    let { loading, error } = this.props.user;
    const { success } = this.props.user.resetPassword;
    const msg = this.getAlertMessage(success);

    return (
      <React.Fragment>
        <div className="login-page">
          <Helmet>
            <title>Login | Go Bus Dashboard</title>
          </Helmet>
          <div className="login-widget">
            <div className="login-widget-head">
              <img src="/imgs/logo-border.png" alt="Go Bus Logo"/>
              <h1>Go Bus Dashboard</h1>
            </div>
            <div className="login-widget-content">
              <Alert color="red" msg={error} />
              <Alert color="green" msg={msg} />
              {/* Basic */}
              <form onSubmit={this.login}>
                <h3>Login</h3>
                <div className="form-field">
                  <h5 className="label">Email Address</h5>
                  <input type="email" name="email" disabled={loading} onChange={this.handleChange} />
                </div>
                <div className="form-field">
                  <h5 className="label">Password</h5>
                  <input type="password" name="password" disabled={loading} onChange={this.handleChange}/>
                </div>
                <Btn className="btn submit full" disabled={loading}>Login</Btn>
                <NavLink to="/forgot-password" className="lnk" >Forgot Password?</NavLink>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  login: bindActionCreators(login, dispatch),
  cleanUp: bindActionCreators(cleanUp, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withRouter(
    withStyles(styles)(Login)
  ));